// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"8a23a727","436":"654827a6","453":"f394a27d","501":"cdfd1308","606":"a5682bb0","925":"75f64e71"}[chunkId] + ".chunk.js";
};